import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=070e0d6a"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=070e0d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports